import { Injectable } from '@angular/core';
import {environment} from "../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";

interface SelectElements {
  value: string;
  viewValue: string;
}
interface selectElementsListGroup {
  disabled?: boolean;
  name: string;
  list: SelectElements[];
}


@Injectable({
  providedIn: 'root'
})
export class UsefulFunctionsService {

  possibleINCIs: string[];


  constructor(public httpClient: HttpClient,
              public router: Router) { }


  /**
   * Format an array oj object into SelectElements
   * @param array
   */
  formatArraysToSelectElement(array) {

    return array.map(obj => {
      var selectElementList: SelectElements = {
        value: obj.code ? obj.code : obj._id,
        viewValue: obj.name ? obj.name : obj.country,
      }
      return selectElementList
    })
  }

  /**
   *
   * @param value
   * @param array
   */
  _filter(value: string, array: SelectElements[]): SelectElements[] {
    const filterValue = value.toLowerCase();
    return array.filter(elm => elm.viewValue.toLowerCase().indexOf(filterValue) === 0)
  }

  /**
   *
   * @param objToSort
   * @param fieldByWhichSorting
   * @param AtoZ: boolean
   * @param date : boolean
   * @private
   */
  sort(objToSort, fieldByWhichSorting, AtoZ, date) {
    return objToSort.sort((a, b) => {
      if (AtoZ){
        if (date) return (new Date(a[fieldByWhichSorting]) > new Date(b[fieldByWhichSorting])) ? 1 : (new Date(a[fieldByWhichSorting]) < new Date(b[fieldByWhichSorting])) ? -1 : 0;
        return (a[fieldByWhichSorting] > b[fieldByWhichSorting]) ? 1 : (a[fieldByWhichSorting] < b[fieldByWhichSorting]) ? -1 : 0;
      } else {
        if (date) return (new Date(a[fieldByWhichSorting]) < new Date(b[fieldByWhichSorting])) ? 1 : (new Date(a[fieldByWhichSorting]) > new Date(b[fieldByWhichSorting])) ? -1 : 0;
        return (a[fieldByWhichSorting] < b[fieldByWhichSorting]) ? 1 : (a[fieldByWhichSorting] > b[fieldByWhichSorting]) ? -1 : 0;
      }
    });
  }

  /**
   * Search the ingredients starting with the text typed in the input
   * @param value String The text of the input
   */
  public async searchIngredients(value: string): Promise<string[]> {
    if (value) {
      var incis = await this.httpClient.get(environment.apiUrl +"search/ingredients/"+value).toPromise().catch(err => {
        console.log('error search/ingredients', err)
        return null
      });

      return incis && incis['data'] ? incis["data"] : null //Add the INCIS in the local variable
    } else {
      return []
    }
  }

  /**
   * Download the results data into a JSON file
   * @param results, The JSON object containing the data from the request
   * @param formTitle, The title of the form we are downloading the results from
   */
  downloadData(results:object, formTitle:string) {
    //Download the data
    var exportName = formTitle + "_" + JSON.stringify(new Date())
    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(results));
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", exportName + ".json");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  async goTo(url) {

    if (sessionStorage.getItem("id")) {
      await this.router.navigateByUrl(url).catch(err => console.log(err)) // navigate to the chosen page
    } else {
      await this.router.navigateByUrl('/').catch(err => console.log(err)) // navigate to the chosen page
    }

  }
}
